<template>
	<div class="chat-video-message">
		<video class="video" :src="src" controls></video>
	</div>
</template>

<script>
	export default {
		props:['src']
	}
</script>

<style lang="scss" scoped>
	.chat-video-message {
		display: flex;
		align-items: center;
		.video {
			max-width: 200px;
			max-height: 100px;
	
			.video-slot {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 200px;
				height: 100px;
				font-size: 13px;
				color: #908686;
				background: #efeaea;
			}
		}
	}
</style>
